<div class="page_title">
    <div class="container-fluid">
        <div class="row">
            <div class="col-auto">
                <k-button [type]="KButtonType.KLAiMSButton" [label]="'Back'" [color]="'brand-main'"
                    [icon]="{type: 'kennedys', name: 'back-arrow'}" (buttonClick)="goToPage()">
                </k-button>
            </div>
            <div class="col">
                <h3>Breach of Duty</h3>
                <app-custom-breadcrumb *ngIf="customData" [data]="customData"></app-custom-breadcrumb>
            </div>
        </div>
    </div>
</div>
<div class="container-fluid">
    <div class="pages_space">
        <div class="row">
            <div class="col">
                    <p class="mb-1"><b>Dose Summary</b></p>
            </div>
            <div class="col-auto">
                <p class="mb-1"><b>Total Dose : {{this.totalDose}}</b></p>
            </div>
        </div>
        <section>
            <k-table-grid></k-table-grid>
        </section>

        <!-- <section class="text-center mt-2">
            <k-button [type]="KButtonType.KLAiMSButton" [label]="'Edit exposure information'" [color]="'brand-main'"
            (buttonClick)="goToExposure()">
        </k-button>
        </section> -->

        <section class="mt-3">
            <canvas baseChart class="breach_canvas" [data]="chartData" [type]="'line'" [options]="chartOptions">
            </canvas>
        </section>
        <section class="mt-3">
            <p class="mb-1 dose_causation_advice">{{this.doseCausationAdvice}}</p>
        </section>
    </div>
</div>

<!-- <div class="row">
    <div class="col-12"  >
        <canvas baseChart  width="400" height="400" 
        [data]="chartData" 
        [type]="'line'"
        [options]="chartOptions">
    </canvas>
    </div>
</div> -->